import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import ArrowTooltip from '../ArrowTooltip';
import Icon from '../Icon';
import Button from '../Button';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 4,
    minWidth: 32,
    minHeight: 32,
    margin: 0,
    marginRight: theme.spacing(1),
    textTransform: 'initial',
    padding: theme.spacing(0.5),
    '&:last-child': {
      marginRight: 0,
    },
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 16,
    margin: 0,
  },
}));

function ActionButton({
  classes, label, icon, color, onClick,
}) {
  const cls = useStyles();
  return (
    <ArrowTooltip title={label}>
      <Button
        classes={{ root: clsx(cls.button, classes.root) }}
        size="small"
        color={color}
        onClick={onClick}
        aria-label={label}
      >
        <Icon classes={{ root: cls.icon }} icon={icon} color="buttonIco" />
      </Button>
    </ArrowTooltip>
  );
}

ActionButton.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'error',
  ]).isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

ActionButton.defaultProps = {
  classes: {},
};

export default ActionButton;
